/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_scroller = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function (
	) {



	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	/**
	 * Check block in view
	 */
	this.checkBlockInView = function (
		scrolled
	) {

		/**
		 * Get: Heights of blocks in an array
		 */
		var blocks = [];
		$('.js-block').each(function () {
			var $block = $(this);

			var $marge_header = $('header').outerHeight();

			blocks.push({
				element: $block,
				top: $block.offset().top - ($marge_header * 2),
				bottom: $block.offset().top + $block.outerHeight() - ($marge_header * 2)
			});
		});

		/**
		 * Check if scrolled is in a block
		 */
		for (var i = 0; i < blocks.length; i++) {
			if (
				scrolled >= blocks[i].top &&
				scrolled <= blocks[i].bottom
			) {

				/**
				 * Active corresponding menu item
				 */
				var block_name = blocks[i].element.data('block');

				$('.js-nav-item').removeClass('active');
				$('.js-nav-item[data-block="' + block_name + '"]').addClass('active');

				/**
				 * Set Url
				 */
				//history.replaceState(null, null, globalUrl + '/' + url[1] + '/' + block_name);

				break;
			} else {
				if (scrolled < blocks[1].top) {
					$('.js-nav-item').removeClass('active');
				}
			}
		}

		/**
		 * If scrolled before .media block, remove all actives
		 */
		if (
			typeof $('.js-spotlight').offset() !== 'undefined'
		) {
			var media_top = $('.js-spotlight').offset().top;
			if (scrolled < media_top) {
				$('.js-nav-item').removeClass('active');
			}
		}

		/**
		 * Check URL and scroll to block
		 */
		this.checkUrl = function (
		) {

			/**
			 * Scroll to .js-block with data-block equal to url[1]
			 */
			var _scroll_to;

			switch (url[2]) {
				case 'informatie': // nl
				case 'information': // en - de
					_scroll_to = 'information';
					break;
				case 'media': // nl - en
				case 'medien': // de
					_scroll_to = 'media';
					break;
				case 'voorzieningen': // nl
				case 'amenities': // en
				case 'ausstattung': // de
					_scroll_to = 'voorzieningen';
					break;
				case 'omgeving': // nl
				case 'surroundings': // en
				case 'umgebung': // de
					_scroll_to = 'omgeving';
					break;
				case 'contact': // nl- en
				case 'kontakt': // de
					_scroll_to = 'contact';
					break;
			}

			/**
			 * Header height
			 */
			var _header_height = $('header').outerHeight();

			/**
			 * Scroll
			 */
			if (typeof _scroll_to !== 'undefined') {
				var $target = $('.js-block[data-block="' + _scroll_to + '"]');
				if ($target.length) {
					var target_offset = $target.offset().top - _header_height;
					$('html, body').stop().animate({
						scrollTop: target_offset
					}, 800);
				}
			} else {
				// Scroll to top
				$('html, body').stop().animate({
					scrollTop: 0
				}, 800);
			}

		};

	};

}).apply(specific_scroller);